/* Extracted from snippets/fp-webmcp-guides.liquid on 2026-08-30.
   That snippet inlined 10,698 B of Liquid-free JavaScript into all 156 pages - the largest
   theme-owned inline block on every one, second only to Shopify's own web-pixels-manager - so the
   same bytes were re-downloaded on every navigation instead of being cached once.
   The three settings values stay in the page, because they are the only Liquid in the file. They
   arrive on window.FP_WEBMCP_CFG rather than as bare `var`s: a deferred external script does NOT
   share function scope with the inline one, so the old locals would simply have been undefined
   here. Defaults below mirror the Liquid `| default:` filters so a missing config degrades to the
   documented numbers instead of NaN. */
(function(){
var C=(typeof window!=='undefined'&&window.FP_WEBMCP_CFG)||{};
var FP_SUB=C.sub||[50,28,20];
var FP_SHIP=(typeof C.ship==='number')?C.ship:35;
/* FP_SUB = [first-delivery %, its minimum subtotal in $, recurring %], rendered above from
   settings (config/settings_schema.json). Rendered, not typed: these move in Shopify >
   Discounts, and a stale figure here becomes a price claim an answer engine quotes. */
var MC=null,done=false;
var S=JSON.stringify;
var T=function(s,x){var r={content:[{type:"text",text:s}]};if(x)r.structuredContent=x;return r;};
/* E marks a real failure. MCP hosts read isError; success-shaped errors are counted as answers. */
var E=function(s){return{content:[{type:"text",text:s}],isError:true,structuredContent:{error:s}};};
var G=async function(u,acc){var r;try{r=await fetch(u,{headers:{accept:acc}});}catch(e){return{e:"request failed: "+e};}return r.ok?{t:await r.text()}:{e:"returned HTTP "+r.status};};
var regTools=function(){
MC.registerTool({
 name:"search_guides",
 description:"Search Foodiepaws' Chew Guide at /blogs/guides - articles on chew sizing, safety and puppies. For LEARNING, not buying. Returns handles for get_guide. At most 10 matches per call and there is no page argument: narrow the query to reach the rest.",
 inputSchema:{type:"object",required:["query"],properties:{query:{type:"string",description:"Plain words, e.g. 'puppy first bully stick'. AND, NOT and \"quoted phrases\" work - 'lamb NOT trotter' reaches guides the first 10 leave out."}}},
 execute:async function(a){
 var q=String((a&&a.query)||"").trim(),d;
 var g=await G("/search?view=agent&type=article&q="+encodeURIComponent(q),"application/json");
 if(g.e)return E("Guide search "+g.e+".");
 try{d=JSON.parse(g.t);}catch(e){return E("Guide view sent non-JSON: "+g.t.slice(0,160));}
 var lim=d.limit||10,sc={query:q,total:d.total,returned:d.returned,limit:lim,results:d.results||[]};
 /* zero matches is an empty answer, not a failure: T, not E. */
 if(!d.results||!d.results.length)return T("No guide matched "+S(q)+". Try a broader word.",sc);
 var cap=d.total>d.returned?" This view returns "+lim+" per call and ignores page; narrow with AND, NOT or a quoted phrase for the rest.":"";
 return T("Guides for "+S(q)+": "+d.returned+" of "+d.total+"."+cap+" Pass a handle to get_guide.\n"+S(d.results),sc);
 }
});
MC.registerTool({
 name:"get_guide",
 description:"Read one Foodiepaws guide by handle from search_guides. Returns title and body text, markup stripped.",
 inputSchema:{type:"object",required:["handle"],properties:{handle:{type:"string",description:"Bare slug like 'bully-stick-size-guide'; lowercase, digits, hyphens. Not a URL."}}},
 execute:async function(a){
 var h=String((a&&a.handle)||"").trim().toLowerCase();
 if(h.length>120||!/^[a-z0-9]+(-[a-z0-9]+)*$/.test(h))return E("Refused "+S(h)+": use a lowercase slug from search_guides.");
 var g=await G("/blogs/guides/"+h,"text/html");
 if(g.e)return E("/blogs/guides/"+h+" "+g.e+".");
 var doc=new DOMParser().parseFromString(g.t,"text/html"),b=doc.querySelector(".fpa-body");
 if(!b)return E("/blogs/guides/"+h+": no article body.");
 var t=b.textContent.replace(/\s+/g," ").trim(),h1=doc.querySelector("h1");
 var ttl=(h1&&h1.textContent.trim())||h,cut=t.length>14000;
 /* the body stays in content, not structuredContent - duplicating 14 KB buys nothing. */
 return T("# "+ttl+"\nSource: /blogs/guides/"+h+"\n\n"+(cut?t.slice(0,14000)+" [truncated]":t),{handle:h,title:ttl,url:"/blogs/guides/"+h,chars:t.length,truncated:cut});
 }
});
var STUB="End a long-stick session at three inches remaining, or sooner if the piece could fit entirely inside the dog's mouth. Trade for a small reward and discard the stub. Always supervise.";
var RULE="Foodiepaws sizing rule (published on site): under 25 lb -> 4-inch; 25 to under 60 lb -> 6-inch; 60 lb+ -> 12-inch. These are starting bands; follow product-specific guidance, including the thin under-25-lb product and mixed-pack component fit.";
var LEN={small:"4-inch",medium:"6-inch",large:"12-inch"};
var THIN="5-6-inch-thin-bully-sticks-25-count",BITES="bully-stick-bites",B4="4-bully-sticks-bulk",B12="12-bully-sticks";
var BEEF={small:{thin:THIN,standard:B4,jumbo:B4},
 medium:{thin:"6-bully-sticks",standard:"6-bully-sticks",jumbo:"6-jumbo-bully-sticks"},
 large:{thin:B12,standard:B12,jumbo:"12-jumbo-bully-sticks"}};
var LAMB={collagen:{medium:"collagen",large:"12-inch-lamb-collagen-sticks-3-count"},
 tripe:{medium:"tripe",large:"12-inch-lamb-tripe-sticks-4-count"}};
var VARI="variety,lamb-collagen-tripe-bully-stick-variety-pack-15-count";
MC.registerTool({
 name:"find_chew_for_dog",
 description:"Apply Foodiepaws' published sizing rule to a dog, returning real product handles. Use when a shopper gives a weight or asks which size. Carries a safety line - relay it.",
 inputSchema:{type:"object",required:["weight_lb"],properties:{
 weight_lb:{type:"number",description:"Weight in pounds; decides LENGTH alone."},
 chew_style:{type:"string",enum:["thin","standard","jumbo"],description:"THICKNESS only: thin = light, jumbo = power chewer. Default standard."},
 protein:{type:"string",enum:["beef","lamb-collagen","lamb-tripe","variety"],description:"beef = bully sticks; lamb-tripe = the richest, meatiest flavor, the pick for a picky eater; every Foodiepaws chew is odor free. Default beef."}}},
 execute:async function(a){
 a=a||{};
 var w=Number(a.weight_lb);
 if(!isFinite(w)||w<=0||w>300)return E("weight_lb must be pounds, e.g. 42.");
 var size=w<25?"small":w<60?"medium":"large";
 var s=String(a.chew_style||"").toLowerCase(),p=String(a.protein||"").toLowerCase();
 var style=/thin|light/.test(s)?"thin":/jumbo|power|heavy/.test(s)?"jumbo":"standard";
 var prot=/collagen/.test(p)?"collagen":/trip/.test(p)?"tripe":/variet|mix/.test(p)?"variety":(p===""||/beef|bully|pizzle/.test(p))?"beef":null;
 /* An unrecognised protein used to fall through to beef, so protein:"chicken" or "duck" returned
    bully sticks as though they matched. The enum is declared; honour it. Empty is still beef. */
 if(prot===null)return E("protein "+S(String(a.protein))+" is not one this store sells. Use beef, lamb-collagen, lamb-tripe or variety - the whole range is beef pizzle, lamb collagen and lamb green tripe.");
 var picks=[],n=[];
 if(prot==="beef"){
 picks=[BEEF[size][style]];
 if(size==="small"){picks.push(BITES);
 if(style==="jumbo")n.push("No jumbo at 4 inches; weight sets length, so standard stands.");
 if(style==="thin")n.push("The thin 5-6-inch product is stated for dogs under 25 lb; choose by mouth fit and supervise.");}
 if(size==="medium"&&style==="thin")n.push("The standalone thin product is for dogs under 25 lb; standard 6-inch is the option in this weight band.");
 if(size==="large"&&style==="thin")n.push("No thin stick at 12 inches; standard is thinnest there.");
 }else if(prot==="variety"){
 if(w>=25){picks=VARI.split(",");n.push("Mixed packs contain different chew profiles. Choose each component for the individual dog by its stated guidance and mouth fit; not every piece suits every dog. The 15-count pack includes beef.");}
 else{n.push("No variety pack is recommended below 25 lb. Choose an individual product within its stated guidance instead.");picks=[];}
 }else if(LAMB[prot][size]){
 picks=[LAMB[prot][size]];
 n.push("Lamb "+prot+" has one thickness, so chew style is moot.");
 }else{
 n.push("No lamb "+prot+" product matches this weight band. Our lamb chews start at 25 lb. We have not substituted beef for your requested protein.");
 picks=[];
 }
 /* Every Foodiepaws chew is odor free — bully sticks, lamb collagen, lamb tripe and the
    variety packs (owner fact, 2026-09-07). This note used to call tripe "strong-smelling by
    design"; raw green tripe is, our dried stick is not. The picky-eater pitch is FLAVOUR. */
 if(/trip|variet/.test(prot))n.push("Lamb tripe carries the richest, meatiest flavor of the range — the one picky eaters take to — and, like every Foodiepaws chew, it is odor free.");
 var out=picks.filter(Boolean);
 /* Bare handles gave the agent nothing to rank or compare on, and no way to see the free-shipping
    line, so it either guessed a price or made a second round trip per pick. At most 3 picks, so
    three parallel reads of the live .js is the cheapest way to return real money. A pick whose
    fetch fails still ships as a handle - a missing price must not drop a valid recommendation. */
 var money=function(c){return"$"+(c/100).toFixed(2);};
 var priced=await Promise.all(out.map(async function(x){
  var g=await G("/products/"+x+".js","application/json");
  if(g.e)return{handle:x,url:"/products/"+x};
  try{var d=JSON.parse(g.t);
   var av=(d.variants||[]).filter(function(v){return v.available;});
   return{handle:x,url:"/products/"+x,title:d.title,
    price_from_usd:money(d.price_min),price_to_usd:money(d.price_max),
    pack_sizes:(d.variants||[]).length,
    cheapest_free_shipping_pack:(function(){
     var f=av.filter(function(v){return v.price>=FP_SHIP*100;}).sort(function(a,b){return a.price-b.price;})[0];
     return f?{variant_id:f.id,title:f.title,price_usd:money(f.price)}:null;})()};
  }catch(e){return{handle:x,url:"/products/"+x};}
 }));
 var line=function(q){return q.handle+" -> "+q.url+(q.price_from_usd?" "+q.price_from_usd+(q.price_to_usd!==q.price_from_usd?"-"+q.price_to_usd:"")+" ("+q.pack_sizes+" pack sizes)":"");};
 return T(RULE+"\nA "+w+" lb dog is in the "+LEN[size]+" band ("+style+", "+prot+").\n\nRecommended:\n"+
 (priced.length?priced.map(line).join("\n"):"No matching product for the requested protein and weight.")+
 "\n\nUS shipping is free at $"+FP_SHIP+" and up, measured on the merchandise subtotal after discounts, excluding shipping and tax."+
 (n.length?"\n\nNotes: "+n.join(" "):"")+"\n\nSAFETY, always relay: "+STUB+
 "\n\nUnsure? Quiz: /pages/find-my-chew.",
 {weight_lb:w,band:LEN[size],chew_style:style,protein:prot,picks:out,products:priced,
  free_shipping_threshold_usd:FP_SHIP,currency:"USD",notes:n,safety:STUB,rule:RULE});
 }
});
MC.registerTool({
 name:"get_subscription_options",
 description:"Subscribe & Save terms and delivery-plan IDs for one Foodiepaws product, read live from the storefront. Read-only - it never touches the cart. Use before recommending a repeat purchase.",
 inputSchema:{type:"object",required:["handle"],properties:{handle:{type:"string",description:"Bare product slug like '6-bully-sticks'. Not a URL."}}},
 execute:async function(a){
 var h=String((a&&a.handle)||"").trim().toLowerCase(),d;
 if(h.length>120||!/^[a-z0-9]+(-[a-z0-9]+)*$/.test(h))return E("Refused "+S(h)+": use a lowercase product slug, e.g. 6-bully-sticks.");
 var g=await G("/products/"+h+".js","application/json");
 if(g.e)return E("/products/"+h+".js "+g.e+".");
 try{d=JSON.parse(g.t);}catch(e){return E("/products/"+h+".js sent non-JSON: "+g.t.slice(0,160));}
 var grp=(d.selling_plan_groups||[])[0],pl=(grp&&grp.selling_plans)||[];
 /* no plan is a true answer about that product, not a failure. */
 if(!pl.length)return T(d.title+" (/products/"+h+") carries no subscription plan; it is one-time purchase only.",{handle:h,title:d.title,subscription:false,plans:[]});
 var plans=pl.map(function(p){var v=(p.price_adjustments||[])[0];
 return{id:p.id,name:p.name,percent_off:v&&v.value_type==="percentage"?v.value:null,url:"/products/"+h+"?selling_plan="+p.id};});
 /* Percentages without prices made the agent do the arithmetic itself, and its answer was a price
    checkout would not honour. Shopify sends variant price in MINOR units on /products/<h>.js, so
    every figure below is derived from the live payload, never from a literal. */
 var money=function(c){return"$"+(c/100).toFixed(2);};
 var recur=FP_SUB[2],first=FP_SUB[0];
 var vs=(d.variants||[]).map(function(v){
  var sub=Math.round(v.price*(100-recur)/100), one=Math.round(v.price*(100-first)/100);
  return{id:v.id,title:v.title,available:v.available,
   price_usd:money(v.price),
   subscription_price_usd:money(sub),
   first_delivery_price_usd:money(one),
   first_delivery_price_applies:sub>=FP_SUB[1]*100,
   free_shipping:(sub>=FP_SUB[1]*100?one:sub)>=FP_SHIP*100,
   recurring_free_shipping:sub>=FP_SHIP*100};});
 var terms=FP_SUB[2]+"% off every delivery. The FIRST delivery is "+FP_SUB[0]+"% off on a subscription subtotal of $"+FP_SUB[1]+" or more - that minimum is measured on the subscription subtotal, which is already the discounted plan price, so quote it with the condition attached. Applied automatically at checkout, no code. Skip, change the rhythm or cancel any time.";
 return T(d.title+" - "+grp.name+"\n"+terms+"\n\nPlans:\n"+
 plans.map(function(p){return p.id+" "+p.name+" -> "+p.url;}).join("\n")+
 "\n\nVariants (list / every delivery / first delivery):\n"+vs.map(function(v){return v.id+" "+v.title+" "+v.price_usd+" / "+v.subscription_price_usd+" / "+(v.first_delivery_price_applies?v.first_delivery_price_usd:v.subscription_price_usd+" (under the $"+FP_SUB[1]+" subtotal, so no first-delivery extra)")+(v.free_shipping?" - free US shipping":"")+(v.available?"":" (sold out)");}).join("\n")+
 "\n\nTo subscribe, send the shopper to a plan URL above, or POST /cart/add with id=<variant id> and selling_plan=<plan id>. Do not add it by fetch: this store's cart drawer is closure-scoped and would go stale.",
 {handle:h,title:d.title,subscription:true,group:grp.name,recurring_percent_off:FP_SUB[2],first_delivery_percent_off:FP_SUB[0],first_delivery_min_subtotal_usd:FP_SUB[1],first_delivery_min_basis:"subscription subtotal, after the plan discount",free_shipping_threshold_usd:FP_SHIP,currency:"USD",plans:plans,variants:vs});
 }
});
};
/* document OR navigator - Shopify's own adapter here accepts both, and looks in this order. */
var reg=function(){
 if(done)return;
 MC=window.document?.modelContext||window.navigator?.modelContext;
 if(typeof MC?.registerTool!=="function")return;
 done=true;
 regTools();
};
var later=function(){setTimeout(reg,0);};
reg();
if(!done){
 /* Shopify's own shape: wait for DOMContentLoaded, then for the async #shopify-origin-trials
    script that injects the WebMCP origin-trial token, then take one turn of the event loop.
    Its inline onload/onerror sets __shopifyOriginTrialsDone, so an already-finished script is
    handled by the flag rather than by a listener that would never fire. */
 var start=function(){
  var t=document.getElementById("shopify-origin-trials");
  if(!t||window.__shopifyOriginTrialsDone)return later();
  t.addEventListener("load",later,{once:true});
  t.addEventListener("error",later,{once:true});
 };
 if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});
 else start();
 /* belt and braces for an API that arrives later still; done makes a second pass a no-op. */
 window.addEventListener("load",later,{once:true});
}
})();
